import React from "react";
import { Grid, } from "@components";
import CircularProgress from "@components/CircularProgress";
import Typography from "@components/Typography";
import LinearProgress from "@components/LinearProgress";

const Loader = ({ type = "circular", message = "", fullHeight = true, size = 40, style = {} }) => (
  <Grid
    container
    direction="row"
    justifyContent="center"
    alignItems="center"
    style={{ height: fullHeight === true ? (type === "linear" ? "100vh": "100%") : null, padding: "5em", display: "flex", flexDirection: "column", ...style }}
  >
    {message && <Typography variant="body2">{message}</Typography>}
    {type === "linear" && <LinearProgress style={{ marginTop: message ? "15px" : 0, width: "30%" }} color="primary" />}
    {type === "circular" && <CircularProgress style={{ width: size, height: size, marginTop: message ? "15px" : 0 }} color="primary" />}
  </Grid>
);

export default Loader;
